// -------------------------------------------------------------------------------

// PLEASE DO NOT EDIT THIS FILE, IT IS GENERATED AND WILL BE OVERWRITTEN:
// https://github.com/ccxt/ccxt/blob/master/CONTRIBUTING.md#how-to-contribute-code

// -------------------------------------------------------------------------------

import { Dict } from '../base/types.js';
import { Exchange as _Exchange } from '../base/Exchange.js';

interface Exchange {
    publicGetOrderbook (params?: {}): Promise<Dict>;
    publicGetTicker (params?: {}): Promise<Dict>;
    publicGetTickerUtc (params?: {}): Promise<Dict>;
    publicGetTrades (params?: {}): Promise<Dict>;
    v2PublicGetRangeUnits (params?: {}): Promise<Dict>;
    v2PublicGetMarketsQuoteCurrency (params?: {}): Promise<Dict>;
    v2PublicGetMarketsQuoteCurrencyTargetCurrency (params?: {}): Promise<Dict>;
    v2PublicGetOrderbookQuoteCurrencyTargetCurrency (params?: {}): Promise<Dict>;
    v2PublicGetTradesQuoteCurrencyTargetCurrency (params?: {}): Promise<Dict>;
    v2PublicGetTickerNewQuoteCurrency (params?: {}): Promise<Dict>;
    v2PublicGetTickerNewQuoteCurrencyTargetCurrency (params?: {}): Promise<Dict>;
    v2PublicGetTickerUtcNewQuoteCurrency (params?: {}): Promise<Dict>;
    v2PublicGetTickerUtcNewQuoteCurrencyTargetCurrency (params?: {}): Promise<Dict>;
    v2PublicGetCurrencies (params?: {}): Promise<Dict>;
    v2PublicGetCurrenciesCurrency (params?: {}): Promise<Dict>;
    v2PublicGetChartQuoteCurrencyTargetCurrency (params?: {}): Promise<Dict>;
    privatePostAccountDepositAddress (params?: {}): Promise<Dict>;
    privatePostAccountBtcDepositAddress (params?: {}): Promise<Dict>;
    privatePostAccountBalance (params?: {}): Promise<Dict>;
    privatePostAccountDailyBalance (params?: {}): Promise<Dict>;
    privatePostAccountUserInfo (params?: {}): Promise<Dict>;
    privatePostAccountVirtualAccount (params?: {}): Promise<Dict>;
    privatePostOrderCancelAll (params?: {}): Promise<Dict>;
    privatePostOrderCancel (params?: {}): Promise<Dict>;
    privatePostOrderLimitBuy (params?: {}): Promise<Dict>;
    privatePostOrderLimitSell (params?: {}): Promise<Dict>;
    privatePostOrderCompleteOrders (params?: {}): Promise<Dict>;
    privatePostOrderLimitOrders (params?: {}): Promise<Dict>;
    privatePostOrderOrderInfo (params?: {}): Promise<Dict>;
    privatePostTransactionAuthNumber (params?: {}): Promise<Dict>;
    privatePostTransactionHistory (params?: {}): Promise<Dict>;
    privatePostTransactionKrwHistory (params?: {}): Promise<Dict>;
    privatePostTransactionBtc (params?: {}): Promise<Dict>;
    privatePostTransactionCoin (params?: {}): Promise<Dict>;
    v2PrivatePostAccountBalance (params?: {}): Promise<Dict>;
    v2PrivatePostAccountDepositAddress (params?: {}): Promise<Dict>;
    v2PrivatePostAccountUserInfo (params?: {}): Promise<Dict>;
    v2PrivatePostAccountVirtualAccount (params?: {}): Promise<Dict>;
    v2PrivatePostOrderCancel (params?: {}): Promise<Dict>;
    v2PrivatePostOrderLimitBuy (params?: {}): Promise<Dict>;
    v2PrivatePostOrderLimitSell (params?: {}): Promise<Dict>;
    v2PrivatePostOrderLimitOrders (params?: {}): Promise<Dict>;
    v2PrivatePostOrderCompleteOrders (params?: {}): Promise<Dict>;
    v2PrivatePostOrderQueryOrder (params?: {}): Promise<Dict>;
    v2PrivatePostTransactionAuthNumber (params?: {}): Promise<Dict>;
    v2PrivatePostTransactionBtc (params?: {}): Promise<Dict>;
    v2PrivatePostTransactionHistory (params?: {}): Promise<Dict>;
    v2PrivatePostTransactionKrwHistory (params?: {}): Promise<Dict>;
    v2_1PrivatePostAccountBalanceAll (params?: {}): Promise<Dict>;
    v2_1PrivatePostAccountBalance (params?: {}): Promise<Dict>;
    v2_1PrivatePostAccountTradeFee (params?: {}): Promise<Dict>;
    v2_1PrivatePostAccountTradeFeeQuoteCurrencyTargetCurrency (params?: {}): Promise<Dict>;
    v2_1PrivatePostOrderLimit (params?: {}): Promise<Dict>;
    v2_1PrivatePostOrderCancel (params?: {}): Promise<Dict>;
    v2_1PrivatePostOrderCancelAll (params?: {}): Promise<Dict>;
    v2_1PrivatePostOrderOpenOrders (params?: {}): Promise<Dict>;
    v2_1PrivatePostOrderOpenOrdersAll (params?: {}): Promise<Dict>;
    v2_1PrivatePostOrderCompleteOrders (params?: {}): Promise<Dict>;
    v2_1PrivatePostOrderCompleteOrdersAll (params?: {}): Promise<Dict>;
    v2_1PrivatePostOrderInfo (params?: {}): Promise<Dict>;
    v2_1PrivatePostTransactionKrwHistory (params?: {}): Promise<Dict>;
    v2_1PrivatePostTransactionCoinHistory (params?: {}): Promise<Dict>;
    v2_1PrivatePostTransactionCoinWithdrawalLimit (params?: {}): Promise<Dict>;
}
abstract class Exchange extends _Exchange {}

export default Exchange
